"use strict";

var app = angular.module('rmFormBuilder');

app.config(function ($stateProvider) {

	$stateProvider

        .state('formbuilder', {
            url: "/formbuilder",
            templateUrl: '/partial/app.partials.formbuilder.add',
            controller: 'FormBuilderFormCtrl',
            controllerAs: 'formbuilder'
            
        }).state('formbuilder.addFormBuilder', {
			url: "/addformbuilder",
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.formbuilder.add',
                    controller: 'FormBuilderFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
		}).state('formbuilder.updateFormBuilder', {
			url: "/addformbuilder/{formbuilderId}",
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.formbuilder.add',
                    controller: 'FormBuilderFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
		});
});